import IconBlock1 from 'images/organization/freeDns/group-118.svg'
import IconBlock2 from 'images/organization/freeDns/group-119.svg'
import IconBlock3 from 'images/organization/freeDns/union.svg'
import NoLoggingIcon from 'images/organization/freeDns/no-logging.svg'
import AnycastNetworkIcon from 'images/organization/freeDns/anycast-network.svg'
import SecureProtocolIcon from 'images/organization/freeDns/secure-protocol.svg'
import { CONTROLDText } from 'ui/CONTROLD'

export const heroSectionData = [
  {
    key: 'block-1',
    icon: IconBlock1,
    title: 'No Logging',
    text: `Don't stress about browser tracking — ${CONTROLDText} doesn't store any DNS queries.`,
    color: 'berryBlue',
    iconBg: NoLoggingIcon,
  },
  {
    key: 'block-2',
    icon: IconBlock2,
    title: 'Anycast Network',
    text: 'Engineered for minimal latency and high-speed performance, delivering an efficient browsing experience.',
    color: 'banana',
    iconBg: AnycastNetworkIcon,
  },
  {
    key: 'block-3',
    icon: IconBlock3,
    title: 'Secure Protocol',
    text: 'Supports advanced DNS encryption protocols, including DNS over HTTPS (DoH) and DNS over TLS (DoT).',
    color: 'successOpaque',
    iconBg: SecureProtocolIcon,
  },
]
